import type { IWorkspaceMember } from '@platform/core/types';

/**
 * Учасники для комбобокса людей (UIUX/field-types/person; прототип fieldVM user · lkAdv): пошук за ім'ям або ел. поштою з першого символу
 * без регістру; порядок — як у переданому списку (порядок членства, поточний користувач першим: useWorkspaceMembers), як у прототипі;
 * повертає всі збіги (список показує перші 8).
 */
export function memberOptions(members: readonly IWorkspaceMember[], query: string): IWorkspaceMember[] {
  const q = query.trim().toLowerCase();
  return members.filter((m) => !q || `${m.user.name} ${m.email ?? ''}`.toLowerCase().includes(q));
}
